<ng-container *ngIf="logoutLoader">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>
<div class="headerBlock" >

    <div class="headerReight" mat-button [matMenuTriggerFor]="menu">
        <span><i class="fa fa-user" aria-hidden="true"></i></span>
        <label>User Name</label>
        <mat-icon>keyboard_arrow_down</mat-icon>
    </div>

    <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="profile()">
            <mat-icon>account_circle</mat-icon> Update Profile
        </button>
        <button mat-menu-item (click)="changePassword()">
            <mat-icon>vpn_key</mat-icon> Change Password
        </button>
        <button mat-menu-item (click)="logout()">
            <mat-icon>power_settings_new</mat-icon> Logout
        </button>
    </mat-menu>

</div>